module.exports = __webpack_public_path__ + "img/tr.67d861f1.png";